module.exports = "data:text/x-markdown;base64,Q29uZ3JhdHMhCgpUaGlzIGJ1ZyBpcyBmcm9tIGEgZmFtb3VzIGdhbWUgKipGb21vM0QqKi4KWW91IGNhbiBnZXQgbW9yZSBpbmZvcm1hdGlvbiBbaGVyZV0oaHR0cHM6Ly9oYWNrZXJub29uLmNvbS9hLWNvbXByZWhlbnNpdmUtc29sdXRpb24tdG8tYnVncy1pbi1mb21vM2QtbGlrZS1nYW1lcy1hYjNiMDU0ZjNjYzUpCgpMb29raW5nIGZvcndhcmQgdG8gbWVldGluZyB5b3UgYXQgQ3Jvc3NsaW5rIDIwMTkh"


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/Fomo4D_complete.md
// module id = 1350
// module chunks = 0